module.exports = __webpack_public_path__ + "img/singleLineTextEle.9b4ce672.svg";